export enum ReviewRequestStrategy {
	ByHand = 0,
	AskAfterCompleteStatus = 1,
	SendAfterCompleteStatus = 2,
	Disable = 3,
}

export const ReviewRequestStrategyNames = {
	[ReviewRequestStrategy.Disable]: 'Disable',
	[ReviewRequestStrategy.ByHand]: 'By Hand',
	[ReviewRequestStrategy.AskAfterCompleteStatus]: 'Ask After Complete Status',
	[ReviewRequestStrategy.SendAfterCompleteStatus]: 'Send After Complete Status',
};
